import { Preference, PreferenceKey } from "types";

export const findByKey = <T>(preferences: Array<Preference<T>>, key: PreferenceKey) => {
    return preferences.find((preference) => preference.key === key) ?? null;
};
